import React from 'react';

const DomainFilter = ({ selectedDomain, onDomainChange, domains }) => {
  const domainOptions = [
    { key: 'all', label: 'All Courses', emoji: '📚' },
    { key: 'ai', label: 'AI & ML', emoji: '🤖' },
    { key: 'neuro', label: 'Neuroscience', emoji: '🧠' },
    { key: 'auto', label: 'Automation', emoji: '⚙️' },
    { key: 'manuf', label: 'Manufacturing', emoji: '🏭' },
    { key: 'cs', label: 'Computer Science', emoji: '💻' },
    { key: 'bio', label: 'Biology', emoji: '🧬' },
    { key: 'math', label: 'Mathematics', emoji: '📐' },
    { key: 'physics', label: 'Physics', emoji: '⚛️' },
    { key: 'ios', label: 'iOS Development', emoji: '📱' },
    { key: 'devops', label: 'DevOps', emoji: '🚀' },
    { key: 'security', label: 'Security', emoji: '🔐' },
    { key: 'web', label: 'Web Development', emoji: '🌐' },
    { key: 'data', label: 'Data & Databases', emoji: '📊' },
    { key: 'testing', label: 'Testing & QA', emoji: '🔍' },
    { key: 'tools', label: 'Developer Tools', emoji: '🛠️' },
    { key: 'automation', label: 'System Automation', emoji: '⚡' },
  ];

  return (
    <div className="mb-12 text-center">
      <h2 className="text-lg font-semibold text-gray-900 mb-6">
        Filter by Domain
      </h2>
      <div className="flex flex-wrap gap-3 justify-center max-w-4xl mx-auto">
        {domainOptions.map((domain) => (
          <button
            key={domain.key}
            onClick={() => onDomainChange(domain.key)}
            className={`
              inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all duration-200
              focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
              ${selectedDomain === domain.key 
                ? 'bg-primary-600 text-white shadow-sm hover:bg-primary-700' 
                : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 hover:border-gray-400'
              }
            `}
          >
            <span className="mr-1.5">{domain.emoji}</span>
            {domain.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DomainFilter;